import { ARROW_SIZE, SPACING_FROM_NEAREST_CORNER } from './constants.js';
import { Inset, Shape, Shadows, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { AnchoredLayerPosition } from '@doordash/component-layer-manager';

// a pattern that should be looked at so we can properly type this.

var TooltipContainer = styled(Inset).attrs({
  innerRef: function innerRef(props) {
    return props.innerRef;
  }
}).withConfig({
  displayName: "styles__TooltipContainer",
  componentId: "sc-j9mwbp-0"
})(["background:", ";border-radius:", "px;box-shadow:", ";display:flex;align-items:flex-start;"], function (props) {
  return props.tooltipType.Normal.Background;
}, function (props) {
  return props.containerShape === Shape.Pill ? props.size * 2 : props.borderRadius;
}, Shadows.Large);
var TooltipButton = styled.button.withConfig({
  displayName: "styles__TooltipButton",
  componentId: "sc-j9mwbp-1"
})(["appearance:none;outline:none;border:none;padding:0;height:32px;width:32px;border-radius:", "px;display:flex;align-items:center;justify-content:center;flex-shrink:0;cursor:pointer;", " &:focus{", ";}"], function (props) {
  return props.borderRadius;
}, function (_ref) {
  var tooltipType = _ref.tooltipType,
      size = _ref.size;
  return css(["border:4px solid ", ";margin:-", "px;background:", ";color:", ";&:hover{background:", ";color:", ";}&:active{background:", ";color:", ";}"], tooltipType.Normal.Background, size / 4, tooltipType.Normal.Background, tooltipType.Normal.Foreground, tooltipType.Hovered.Background, tooltipType.Hovered.Foreground, tooltipType.Pressed.Background, tooltipType.Hovered.Foreground);
}, getFocusStyles());
var IconContainer = styled(Inset).withConfig({
  displayName: "styles__IconContainer",
  componentId: "sc-j9mwbp-2"
})(["max-height:24px;display:flex;align-items:center;"]);

var getStyleForPosition = function getStyleForPosition(_ref2) {
  var position = _ref2.position,
      tooltipType = _ref2.tooltipType;

  switch (position) {
    case AnchoredLayerPosition.TopLeft:
    case AnchoredLayerPosition.TopCenter:
    case AnchoredLayerPosition.TopRight:
      {
        var TRIANGLE = css(["border-left:", "px solid transparent;border-right:", "px solid transparent;border-top:", "px solid ", ";bottom:-", "px;"], ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, tooltipType.Normal.Background, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.TopLeft:
          case AnchoredLayerPosition.TopRight:
            return css(["", ";", ":", "px;"], TRIANGLE, position === AnchoredLayerPosition.TopLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayerPosition.TopCenter:
          default:
            return css(["", ";left:0px;right:0px;"], TRIANGLE);
        }
      }

    case AnchoredLayerPosition.RightTop:
    case AnchoredLayerPosition.RightCenter:
    case AnchoredLayerPosition.RightBottom:
      {
        var _TRIANGLE = css(["border-top:", "px solid transparent;border-bottom:", "px solid transparent;border-right:", "px solid ", ";left:-", "px;"], ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, tooltipType.Normal.Background, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.RightTop:
          case AnchoredLayerPosition.RightBottom:
            return css(["", ";", ":", "px;"], _TRIANGLE, position === AnchoredLayerPosition.RightTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayerPosition.RightCenter:
          default:
            return css(["", ";margin:auto;top:0px;bottom:0px;"], _TRIANGLE);
        }
      }

    case AnchoredLayerPosition.LeftTop:
    case AnchoredLayerPosition.LeftCenter:
    case AnchoredLayerPosition.LeftBottom:
      {
        var _TRIANGLE2 = css(["border-top:", "px solid transparent;border-bottom:", "px solid transparent;border-left:", "px solid ", ";right:-", "px;"], ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, tooltipType.Normal.Background, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.LeftTop:
          case AnchoredLayerPosition.LeftBottom:
            return css(["", ";", ":", "px;"], _TRIANGLE2, position === AnchoredLayerPosition.LeftTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayerPosition.LeftCenter:
          default:
            return css(["", ";margin:auto;top:0px;bottom:0px;"], _TRIANGLE2);
        }
      }

    case AnchoredLayerPosition.BottomLeft:
    case AnchoredLayerPosition.BottomCenter:
    case AnchoredLayerPosition.BottomRight:
      {
        var _TRIANGLE3 = css(["border-left:", "px solid transparent;border-right:", "px solid transparent;border-bottom:", "px solid ", ";top:-", "px;"], ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, tooltipType.Normal.Background, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.BottomLeft:
          case AnchoredLayerPosition.BottomRight:
            return css(["", ";", ":", "px;"], _TRIANGLE3, position === AnchoredLayerPosition.BottomLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayerPosition.BottomCenter:
          default:
            return css(["", ";left:0px;right:0px;"], _TRIANGLE3);
        }
      }

    default:
      return css([""]);
  }
};

var Arrow = styled.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-j9mwbp-3"
})(["width:0;height:0;position:absolute;", ";"], getStyleForPosition);

export { Arrow, IconContainer, TooltipButton, TooltipContainer };
